import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Button, Col, Form, Input, message, Rate, Row } from 'antd';
import "./employessDetail.css";

const EmployessDetail = () => {
  const params = useParams();
  const [form] = Form.useForm();
  const employessId = params.id;
  const [data, setData] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      const response = await fetch(`${apiUrl}/api/employess/${employessId}/reviews`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: values.name,
          text: values.message,
          rating: values.rate,
          phoneNumber: values.phone,
        })
      });

      if (response.ok) {
        message.success("Değerlendirme başarıyla gönderildi.");
        form.resetFields();
        navigate("/calisanlar");
      } else {
        message.error('Değerlendirme gönderilemedi');
      }

    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchSingleEmployess = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/employess/${employessId}`);
        if (response.ok) {
          const data1 = await response.json();
          setData(data1);
        } else {
          message.error("Çalışan verileri getirilemedi");
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchSingleEmployess();
  }, [apiUrl, employessId]);

  if (!data) {
    return <div>Loading...</div>;
  }

  const imgSrc = data.img?.startsWith("http")
    ? data.img
    : `${imageBaseUrl}/${data.img}`;

  return (
    <div className="employess-detail">
      <div className="employess-detail-bg"></div>
      <div className="employess-detail-bg-text"></div>
      <div className="employess-bg-text">
        <h2>Sizlerle Birlikte Daha Güçlüyüz.</h2>
      </div>

      <div className="employess-detail-container">
        <div className="employess-detail-user">
          <div className="detail-img">
            <img src={imgSrc} alt={data.name} />
          </div>
          <div className="detail-line"></div>
          <div className="name-expertise">
            <div className="detail-name">
              <p>{data.name}</p>
            </div>
            <div className="detail-expertise">
              <p>{data.expertise}</p>
            </div>
          </div>
        </div>

        <div className="employess-detail-review-form">
          <Form
            form={form}
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              employeeName: data.name,
            }}
            style={{
              maxWidth: "100%",
              margin: "0 auto",
            }}
          >
            <Row gutter={[16, 16]} justify="center">
              <Col xs={24} sm={24} md={12} lg={8}>
                <Form.Item label="Çalışan İsmi" name="employeeName">
                  <Input disabled />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={8}>
                <Form.Item
                  label="İsminiz"
                  name="name"
                  rules={[{ required: true, message: "Lütfen isminizi giriniz!" }]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={24} lg={16}>
                <Form.Item
                  label="Görüş ve Önerileriniz"
                  name="message"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen bir mesaj yazınız!"
                    },
                    {
                      min: 20,
                      message: "Mesaj en az 20 karakter uzunluğunda olabilir."
                    }
                  ]}
                >
                  <Input.TextArea rows={4} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={24} lg={16}>
                <Form.Item
                  label="Telefon"
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen telefon numaranızı giriniz!",
                    },
                    {
                      pattern: /^(0(\d{10})|(\+90\d{10}))$/,
                      message: "Geçerli bir telefon numarası giriniz!",
                    },
                  ]}
                >
                  <Input placeholder='başa 0 veya +90 koymayı unutmayınız' />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={24} lg={16}>
                <Form.Item
                  label="Rate"
                  name="rate"
                  rules={[{ required: true, message: "Lütfen bir puan verin!" }]}
                >
                  <Rate />
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Button type="primary" htmlType="submit" block>
                  Gönder
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default EmployessDetail;
